(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["Backtrace"] = factory(require("react"));
	else
		root["Backtrace"] = factory(root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__156__) => {
return 